import { render, staticRenderFns } from "./contacts-phone-list.vue?vue&type=template&id=6c9c658a&scoped=true&"
import script from "./contacts-phone-list.vue?vue&type=script&lang=js&"
export * from "./contacts-phone-list.vue?vue&type=script&lang=js&"
import style0 from "./contacts-phone-list.vue?vue&type=style&index=0&id=6c9c658a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9c658a",
  null
  
)

/* custom blocks */
import block0 from "./contacts-phone-list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports